import { useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import AdminAuthContext from "../store/adminStore/admin-auth-context";
import { useNavigate } from "react-router-dom";
import clearERPStores from "../utils/cache/clearERPStores";

const useHttpFetch = (initialLoadingState = false, projectName = "ERP", systemRequest) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(initialLoadingState);
  const [preventForShortTime, setPreventForShortTime] = useState(false);
  const [counter, setCounter] = useState(0);
  const [preventForShortTimeCounter, setPreventForShortTimePersistCounter] = useState(0);
  // const [abort, setAbort] = useState(() => {});
  const { setClientAuthInfo, clientAuthInfo } = useContext(AdminAuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (preventForShortTime) {
      const shortTimeDelay = preventForShortTimeCounter === 0 ? 1 : preventForShortTimeCounter;
      const timer = setTimeout(
        () => {
          setPreventForShortTime(false); // Reset the state to trigger re-render
          setCounter(0);
        },
        shortTimeDelay * 60 * 1000,
      ); // 2 minutes
      setPreventForShortTimePersistCounter((ps) => ps + 1);

      return () => clearTimeout(timer); // Cleanup on unmount or state change
    }
  }, [preventForShortTime]);
  const sendRequest = useCallback(
    async (props) => {
      if (!preventForShortTime) {
        const {
          method,
          url,
          body,
          language,
          calType,
          notEV,
          additionalHeader,
          noMiddleUrl,
          port,
          isBlob,
          isFormData,
          isRedirectRequest,
        } = props;

        let finalLanguage = language ? language : "persian";
        let finalCalType = calType ? calType : "pe";
        const ssoBaseUrl =
          process.env.NODE_ENV === "development" && process.env.NODE_ENV !== "production"
            ? window.localStorage.getItem("baseSSOUrl") ||
              `${process.env.REACT_APP_REQUEST_BASE_URL_8088_PORT}`
            : `${process.env.REACT_APP_REQUEST_BASE_URL_8088_PORT}`;
        const erpBaseUrl =
          process.env.NODE_ENV === "development" && process.env.NODE_ENV !== "production"
            ? window.localStorage.getItem("baseERPUrl") ||
              `${process.env.REACT_APP_REQUEST_BASE_URL_8082_PORT}`
            : `${process.env.REACT_APP_REQUEST_BASE_URL_8082_PORT}`;
        let finalUrl = notEV
          ? url
          : `${
              port === "8082"
                ? erpBaseUrl
                : port === "8088"
                  ? ssoBaseUrl
                  : port === "8083"
                    ? `${process.env.REACT_APP_REQUEST_BASE_URL_8083_PORT}`
                    : port === "9092"
                      ? `${process.env.REACT_APP_REQUEST_BASE_URL_9092_PORT}`
                      : systemRequest === "distribution"
                        ? `${process.env.REACT_APP_Distribution_requests}`
                        : erpBaseUrl
            }${noMiddleUrl ? "" : `${finalCalType}/${finalLanguage}/`}${url}`;
        let resIsOk;
        let resStatus;
        let response;

        setIsLoading(true);
        try {
          // const abortController = new AbortController();
          // const signal = abortController.signal;
          // setAbort(abortController.abort);
          const fetchOptions = {
            method: method ? method : "GET",
            credentials: "include",
            body: body ? (isFormData ? body : JSON.stringify(body)) : null,
            headers: { ...additionalHeader },
          };
          if (!isFormData) {
            fetchOptions.headers = { ...fetchOptions.headers, "Content-Type": "application/json" };
          }
          // console.log("sending http fetch");
          const rawResponse = await fetch(finalUrl, fetchOptions);
          // console.log("sent http fetch");
          resIsOk = rawResponse.ok;
          resStatus = rawResponse.status;
          if (resStatus === 403) {
            if (projectName === "ERP") {
              navigate("/admin/login");
              setClientAuthInfo({
                isLoggedIn: false,
                isLoading: false,
                mobileNumber: null,
                accessibilities: null,
                username: null,
                firstName: null,
                lastName: null,
                userId: null,
                baseUserId: null,
                userTypeEnum: null,
                organizationalTitles: null,
              });
              clearERPStores();
            } else if (projectName === "Applicant") {
              navigate("/applicant-information/login");
            } else if (projectName === "PDD") {
              navigate("/personnel-document-digitization/login");
            } else if (projectName === "SRM") {
              navigate("/sale-representatives-management/login");
            } else if (projectName === "Correspondence") {
              console.log("Correspondence");
            }
          }
          if (isBlob) response = await rawResponse.blob();
          else if (isRedirectRequest) response = rawResponse;
          else response = await rawResponse.json();

          if (!rawResponse.ok) {
            throw new Error(
              response?.message ? response?.message : `HTTP error! Status: ${rawResponse.status}`,
            );
          }
        } catch (error) {
          // console.log(error);
          setError(error || "Something went wrong!");
        } finally {
          if ((method === "POST" || method === "PUT") && !isFormData) {
            setCounter((ps) => ps + 1);
            if (counter >= 10) {
              setCounter((ps) => ps - 1);
              setPreventForShortTime(true);
            }
          }
        }
        setIsLoading(false);
        return { response, resStatus, resIsOk };
      } else {
        toast.error("Too many requests", { toastId: "tooManyReqs" });
        return { response: { message: "Too many requests" }, resStatus: null, resIsOk: null };
      }
    },
    [preventForShortTime, counter],
  );

  return { isLoading, error, sendRequest };
};

export default useHttpFetch;
